import moment, { Moment } from 'moment';

export const setTime = (hour: number, minute?: number, second?: number): Moment =>
  moment().set({ hour, minute: minute || 0, second: second || 0 });
export const setTimeWithDate = (dateStr: moment.MomentInput = moment().format(), hour?: number, minute?: number): Moment =>
  moment(dateStr).set({ hour, minute: minute || 0, second: 0 });

export interface TimeLine {
  id: string;
  value: Moment;
}

const getTimeLines = (startTime: Moment, endTime: Moment, distance = 15): TimeLine[] => {
  const _distance = distance || 30;
  const times: TimeLine[] = [];
  let time = startTime;

  while (time <= endTime) {
    times.push({
      id: time.format('HH:mm'),
      value: time,
    });
    time = time.clone().add(_distance, 'minute');
  }
  return times;
};

export default getTimeLines;
